import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import colors from "assets/theme/base/colors";
import "react-toastify/dist/ReactToastify.css";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import "../campus/Campus.css";
import { hasAdmissionPermission } from "hooks/permissions";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const Departmentv2 = () => {
  // State variables
  const [departments, setDepartments] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [facultyId, setFacultyId] = useState("");
  const [faculties, setFaculties] = useState([]);
  const [showAddDepartmentModal, setShowAddDepartmentModal] = useState(false);
  const [showUpdateDepartmentModal, setShowUpdateDepartmentModal] = useState(false);
  const [showDeleteDepartmentModal, setShowDeleteDepartmentModal] = useState(false);
  const [currentDepartmentId, setCurrentDepartmentId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [formErrors, setFormErrors] = useState({ name: "", description: "", faculty_id: "" });
  const [showViewDepartmentModal, setShowViewDepartmentModal] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  // Get Faculties
  const getFaculties = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${BASE_URL}/faculty/get_faculties`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setFaculties(data.faculties);
      })
      .catch((error) => console.log(error));
  };

  // Add this function to fetch departments
  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${BASE_URL}/department/get_departments`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  // Add department 
  const addDepartment = async () => {
    const data = { name, description, faculty_id: facultyId };
    try {
      const response = await fetch(`${BASE_URL}/department/add_department`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to add department");
      }

      getDepartments();
      toast.success("Department added successfully");
      resetForm();
    } catch (error) {
      toast.error("Failed to add department");
    } finally {
      setShowAddDepartmentModal(false);
    }
  };

  // Delete department
  const deleteDepartment = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/department/delete_department/${currentDepartmentId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete department");
      }

      getDepartments();
      toast.success("Department deleted successfully");
    } catch (error) {
      console.error("Error deleting department:", error);
      toast.error("Failed to delete department");
    } finally {
      setShowDeleteDepartmentModal(false);
    }
  };

  // Update department
  const updateDepartment = async () => {
    const data = { id: currentDepartmentId, name, description, faculty_id: facultyId };
    try {
      const response = await fetch(`${BASE_URL}/department/update_department`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", 
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to update department");
      }

      getDepartments();
      toast.success("Department updated successfully");
      resetForm();
    } catch (error) {
      console.error("Error updating department:", error);
      toast.error("Failed to update department");
    } finally {
      setShowUpdateDepartmentModal(false);
    }
  };

  const handleFocus = (e) => {
    const { name } = e.target;
    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setFacultyId("");
    setFormErrors({ name: "", description: "", faculty_id: "" });
  };

  // Search functionality
  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);
  
    if (searchTerm === "") {
      getDepartments();
    } else {
      const filteredDepartments = departments.filter((department) => {
        const nameMatch = department.name && department.name.toLowerCase().includes(searchTerm);
        const descriptionMatch = department.description && department.description.toLowerCase().includes(searchTerm);
        const facultyMatch = department.faculty_name && department.faculty_name.toLowerCase().includes(searchTerm);
        return nameMatch || descriptionMatch || facultyMatch;
      });
      setDepartments(filteredDepartments);
    }
  };

  const callErrors = (NAME, DESCRIPTION, FACULTYID) => {
    const errors = {};
    if (NAME === "") {
      errors.name = " *Name is Required";
    }
    if (DESCRIPTION === "") {
      errors.description = " *Description is Required";
    }
    if (FACULTYID === "") {
      errors.faculty_id = " *Faculty is Required";
    }
    setFormErrors(errors);
  };

  const handleCancelAddDepartmentModal = () => {
    setShowAddDepartmentModal(false);
    resetForm();
  };

  const handleOkAddDepartmentModal = () => {
    if (name && description && facultyId) {
      addDepartment();
    } else {
      callErrors(name, description, facultyId);
    }
  };

  // Dialog handlers
  const showDepartmentAddModal = () => setShowAddDepartmentModal(true);
  const showDepartmentUpdateModal = (id) => {
    setCurrentDepartmentId(id);
    const department = departments.find((d) => d.id === id);
    setName(department.name);
    setDescription(department.description);
    setFacultyId(department.faculty_id);
    setShowUpdateDepartmentModal(true);
  };

  const showDepartmentDeleteModal = (id) => {
    setCurrentDepartmentId(id);
    setShowDeleteDepartmentModal(true);
  };

  const viewDepartment = (id) => {
    const department = departments.find((d) => d.id === id);
    setSelectedDepartment(department);
    setShowViewDepartmentModal(true);
  };

  // Initial render
  useEffect(() => {
    getDepartments();
    getFaculties();
  }, []);

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Department Name", accessor: "department_name", align: "center" },
    { Header: "Description", accessor: "description", align: "center" },
    { Header: "Faculty", accessor: "faculty_name", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows = departments.map((department, index) => ({
    serial: index + 1,
    department_name: department.name,
    description: department.description,
    faculty_name: department.faculty_name,
    actions: (
      <>
        {hasAdmissionPermission("Department", "UPDATE") && (
        <IconButton onClick={() => showDepartmentUpdateModal(department.id)}>
          <EditIcon className="icon-button-edit" />
        </IconButton>
        )}
        {hasAdmissionPermission("Department", "READ") && (
        <IconButton onClick={() => viewDepartment(department.id)}>
          <VisibilityOutlinedIcon className="icon-button-view" />
        </IconButton>
        )}
        {hasAdmissionPermission("Department", "DELETE") && (
        <IconButton onClick={() => showDepartmentDeleteModal(department.id)}>
          <DeleteIcon className="icon-button-delete" />
        </IconButton>
        )}
      </>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Paper className="search-paper" component="form">
                  <InputBase
                    sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search department" }}
                    value={searchKeyword}
                    onChange={handleSearchKeywordChange}
                  />
                  <SearchIcon className="search-icon" />
                </Paper>
                { hasAdmissionPermission("Department", "CREATE") && (
                <Button
                  className="add-button"
                  variant="filled"
                  endIcon={<AddIcon className="add-icon" />}
                  onClick={showDepartmentAddModal}
                  color="info.main"
                >
                  Add
                </Button>
                )}
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Department Dialog */}
      <Dialog
        open={showAddDepartmentModal}
        onClose={handleCancelAddDepartmentModal}
        maxWidth="lg"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          Add Department
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6 left-fields">
              <div className="form-outline mt-3">
                <label>Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Name"
                />
                <div className="error-message1">{formErrors.name}</div>
              </div>
            </div>
            <div className="col-md-6 mt-3 form-sideline">
              <label>Description</label>
              <input
                placeholder="Description"
                name="description"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onFocus={handleFocus}
                className="form-control form-control-lg"
              />
              <div className="error-message">{formErrors.description}</div>
            </div>
            <div className="col-md-6 mt-3 form-sideline">
              <label>Faculty</label>
              <select
                name="faculty_id"
                value={facultyId}
                onChange={(e) => setFacultyId(e.target.value)}
                onFocus={handleFocus}
                className="form-control form-control-lg"
              >
                <option value="">Select Faculty</option>
                {faculties.map((faculty) => (
                  <option key={faculty.id} value={faculty.id}>
                    {faculty.name}
                  </option>
                ))}
              </select>
              <div className="error-message">{formErrors.faculty_id}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelAddDepartmentModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkAddDepartmentModal}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Department Dialog */}
      <Dialog
        open={showUpdateDepartmentModal}
        onClose={() => setShowUpdateDepartmentModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          Update Department
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder="Enter Name"
                />
                <div className="error-message1">{formErrors.name}</div>
              </div>
            </div>
            <div className="col-md-6 mt-3">
              <label>Description</label>
              <input
                placeholder="Description"
                name="description"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-control form-control-lg"
              />
              <div className="error-message">{formErrors.description}</div>
            </div>
            <div className="col-md-6 mt-3">
              <label>Faculty</label>
              <select
                name="faculty_id"
                value={facultyId}
                onChange={(e) => setFacultyId(e.target.value)}
                className="form-control form-control-lg"
              >
                <option value="">Select Faculty</option>
                {faculties.map((faculty) => (
                  <option key={faculty.id} value={faculty.id}>
                    {faculty.name}
                  </option>
                ))}
              </select>
              <div className="error-message">{formErrors.faculty_id}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowUpdateDepartmentModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={updateDepartment}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Department Dialog */}
      <Dialog
        open={showDeleteDepartmentModal}
        onClose={() => setShowDeleteDepartmentModal(false)}
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle className="dialog-delete">Delete Department</DialogTitle>
        <DialogContent className="content-delete">
          Are you sure you want to delete this department?
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowDeleteDepartmentModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={deleteDepartment}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Department Dialog */}
      <Dialog
        open={showViewDepartmentModal}
        onClose={() => setShowViewDepartmentModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          View Department
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedDepartment && (
            <>
              <div className="flex-container">
                <strong className="label1">Name</strong>
                <span className="value1">{selectedDepartment.name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Description</strong>
                <span className="value1">{selectedDepartment.description}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Faculty</strong>
                <span className="value1">{selectedDepartment.faculty_name}</span>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowViewDepartmentModal(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default Departmentv2;
